if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {
  /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

  // Remove empty <p> tags created by tinymce
  const paragraph = document.querySelectorAll("p") || [];
  paragraph.forEach(
    (e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
  );

  $(".sym-slides").slick({
    accessibility: false,
  });

  //tabs content
  document.querySelectorAll(".tab-js li").forEach((btn, i) => {
    btn.addEventListener("click", (_) => {
      document
        .querySelectorAll(".tab-js li")
        .forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      activeContentItem(btn.dataset.tag);
    });

    if (i === 0) btn.click();
  });
  function activeContentItem(tag) {
    document.querySelectorAll(".tab-item-js").forEach((item) => {
      console.log("item: ",item);
      console.log("item.dataset.tag: ",item.dataset.tag);
      console.log("Tag: ",tag);
      item.classList.remove("active");

      if (tag === "all" || tag === item.dataset.tag) {
        let data_tag = item.getAttribute("data-tag");
        item.classList.add("active");
        console.log("Item.childNodes[3]",item.childNodes[3].childNodes[1]);
        let ul = item.childNodes[3].childNodes[1].childNodes[1];
        let dataTagChild = ul.getAttribute("data-tag");
        if (data_tag != dataTagChild) {
          ul.nextElementSibling.classList.add("active");
        } else {
          ul.classList.add("active");
        }
      }
    });
  }
})();

$(".single-quad-slider").slick({
  arrows: true,
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  fade: true,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows : false
      },
    },
  ],
})

$(".reviews-slider").slick({
  accessibility: true,
  arrows: true,
  fade: true,
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
      },
    },
  ],
});

$(".one-line-slider").slick({
  accessibility: false,
  centerMode: true,
  centerPadding: "150px",
  slidesToShow: 3,
  arrows: true,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        centerMode: false,
        fade: true,
        slidesToShow: 1,
      },
    },
  ],
});

$(".slider-start").slick({
  accessibility: false,
  arrows: true,
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
});
$(".carousel-container__text-slider").slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  asNavFor: ".carousel-container__images-slider",
});

$(".carousel-container__images-slider").slick({
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  asNavFor: ".carousel-container__text-slider",
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
      },
    },
  ],
});

$('.images-carousel-slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        fade: true,
        arrows: false,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
      },
    },
  ],
})

if (document.querySelector(".gallery-slider")) {
  $(".gallery-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility:true,
    fade: true,
  });
}

$(".gallery-desktop-slider").slick({
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: "0px",
  variableWidth: true,
});
